import { render, staticRenderFns } from "./CreationMethodIcon.vue?vue&type=template&id=4c7662e0&lang=pug"
import script from "./CreationMethodIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreationMethodIcon.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports